import { styled } from 'styled-components';

export const CalendarContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(6, 1fr);
  gap: 20px;
  width: 100%;
  padding-top: 2px;
  height: 100%;
`;
